import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ScooterShowcase from "../components/ScooterShowcase";
import Itineraries from "../components/Itineraries";
import Pricing from "../components/Pricing";
import Availability from "../components/Availability";
import GallerySection from "../components/GallerySection";
import Hygiene from "../components/Hygiene";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import BookingDialog from "../components/BookingDialog";
import AuthDialog from "../components/AuthDialog";
import PendingBookingBanner from "../components/PendingBookingBanner";
import { trackPageView, trackClick } from "../lib/analytics";

export default function Landing() {
  const [bookOpen, setBookOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [resumeId, setResumeId] = useState(null);

  // Track page view once per session
  useEffect(() => { trackPageView(); }, []);

  // Deep link support: ?resume=<booking_id> auto-opens the resume flow (used by
  // the recovery email).
  useEffect(() => {
    const url = new URL(window.location.href);
    const rid = url.searchParams.get("resume");
    if (rid) {
      localStorage.setItem("pendingBookingId", rid);
      setResumeId(rid);
      setBookOpen(true);
      url.searchParams.delete("resume");
      window.history.replaceState({}, "", url.pathname + (url.search ? url.search : ""));
    }
  }, []);

  const openFresh = () => { trackClick("click_book"); setResumeId(null); setBookOpen(true); };
  const openResume = (bid) => { setResumeId(bid); setBookOpen(true); };
  const handleOpenChange = (o) => { setBookOpen(o); if (!o) setResumeId(null); };

  return (
    <div className="bg-[#050505] min-h-screen" data-testid="landing-page">
      <Header onBook={openFresh} onLogin={() => setAuthOpen(true)} />
      <main>
        <Hero onBook={openFresh} />
        <ScooterShowcase onBook={openFresh} />
        <Itineraries onBook={openFresh} />
        <Pricing onBook={openFresh} />
        <Availability onBook={openFresh} />
        <GallerySection />
        <Hygiene />
        <FAQ />
      </main>
      <Footer onBook={openFresh} />
      <BookingDialog open={bookOpen} onOpenChange={handleOpenChange} resumeBookingId={resumeId} />
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
      {!bookOpen && <PendingBookingBanner onResume={openResume} />}
    </div>
  );
}
